export const isDev = () => process.env.NODE_ENV === 'development'

export const getApiUrl = () => process.env.VUE_APP_API_DOMAIN + '/api'

export const WEBHOOK_BASE_URL = 'https://api-balancer.dentist-plus.com'
